import { useCallback, useEffect, useState } from 'react';
import * as apiObject from 'api/apiObjects';
import type { HistoryDeadlineRow } from './types';

export const useHistoryDeadline = (objectId: number | null | undefined, show: boolean) => {
    const [history, setHistory] = useState<HistoryDeadlineRow[]>([]);
    const [loading, setLoading] = useState(false);

    const reload = useCallback(async () => {
        if (!objectId) {
            setHistory([]);
            return;
        }
        setLoading(true);
        const rows = await apiObject.getDeadlineHistory(objectId);
        setHistory(Array.isArray(rows) ? rows : []);
        setLoading(false);
    }, [objectId]);

    useEffect(() => {
        if (!show || !objectId) return;
        void reload();
    }, [show, objectId, reload]);

    return { history, loading, reload };
};
